import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { installAuthFetch } from './utils/authFetch';
import { installPrintHandlers } from './print/printMode';

// Attach the bearer token to same-origin /api requests globally, before any component fetches — so
// entitlement-gated page data (Ecosystem, Portfolio, Risk Kernel, …) loads for an authenticated
// subscriber instead of 402-ing on unauthenticated GETs.
installAuthFetch();

// One print mode for every page: the browser's Print command opens every disclosure, switches to the light print
// tokens and draws charts at the printable width, then restores the screen state (src/print/printMode.ts).
installPrintHandlers();

// Global error handler for unhandled errors
window.addEventListener('error', (event) => {
  // Suppress "Script error" from external scripts (CORS)
  if (event.message === 'Script error.') {
    console.warn('External script error (likely CORS):', event.filename);
    event.preventDefault();
    return false;
  }
  console.error('Unhandled error:', event.error);
  return true;
});

// Global handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
